module.exports = __webpack_public_path__ + "img/140.458ece38.png";